import { GetImageParams } from "./paramsTypes";

export const getBankInformationUrl = "portal-person-info/profile/bank-info";

export const getBasicInformationUrl =
  "portal-person-info/profile/personal-info";

export const getEducationInformationUrl = "portal-person-info/profile/academic";

export const getLanguageInformationUrl = "portal-person-info/profile/language";

export const getCertificationInformationUrl = "portal-person-info/profile/cert";

export const getMaritalInformationUrl = "portal-person-info/profile/relative";

export const getResidenceInformationUrl = "portal-person-info/profile/address";

export const getWorkInformationUrl = "portal-person-info/profile/employee-info";

export const getCertificationProfessionalUrl =
  "portal-person-info/profile/professional/certificate";

export const getWorkPerformanceResultUrl =
  "portal-person-info/profile/graded-result";

export const getImageUrl = ({ type }: GetImageParams) =>
  `portal-person-info/profile/${type}/images`;

export const postFileUrl = "portal-person-info/file/upload";

export const getHistoryTimelineUrl = () => "portal-person-info/profile/history";

export const getHistoryDetailUrl = (id: string) =>
  `portal-person-info/profile/${id}/history`;

export const updatePersonalInformationUrl = (screenCode: string): string =>
  `portal-person-info/profile/${screenCode}`;

export const getCheckEditableUrl = (screenCode: string) =>
  `portal-person-info/profile/${screenCode}/check-editable`;
